import EventEmitter from "base/EventEmitter";

class ItemOrderer extends EventEmitter {

    constructor($parent, items = []) {
        super();
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);

        this.items = [];
        this.$parent = $parent;

        this.$originalElement = null;
        this.$draggingElement = null;

        this.buildElement();
        this.bindEvents();

        this.setItems(items);
    }

    buildElement() {
        this.$element = eotwJSXFactory('div', {class: "admin-orderer"});

        this.$parent.html(this.$element)
    }

    bindEvents() {
        const me = this;
        this.$element.on("mousedown", '.js-orderer-item', function (e) {
            return me.handleMouseDown($(this), e);
        }).on("mousedown", '.js-remove-item', function (e) {
            e.stopPropagation();
        }).on("click", ".js-remove-item", function () {
            let item = $(this).parents('.js-orderer-item').data("item");
            if (me.emit('removeItem', {item: item, index: me.items.indexOf(item)})) {
                me.items = me.items.filter((other) => other !== item);

                me.updateList();
            }
            return false;
        });
    }

    destroy() {
        super.destroy();
        this.$element.remove();

        $(window).off('mousemove', this.handleMouseMove).off("mouseup", this.handleMouseUp)
    }

    handleMouseDown($elem, e) {
        this.handleMouseUp();

        this.$originalElement = $elem;
        this.$draggingElement = this.$originalElement.clone();
        this.$element.append(this.$draggingElement);


        this.$originalElement.addClass('admin-orderer__item--placeholder');
        this.$draggingElement.addClass('admin-orderer__item--dragging');

        $(window).on('mousemove', this.handleMouseMove).on("mouseup", this.handleMouseUp);
        this.handleMouseMove(e);
        return false;
    }

    handleMouseMove(e) {
        if (this.$draggingElement !== null) {
            let $dragged = this.$draggingElement;
            let pos = e.pageY - $dragged.parent().offset().top - ($dragged.height() / 2);
            $dragged.css("top", pos);

            let currentIndex = this.$originalElement.index();

            $dragged.siblings('.js-orderer-item').each((index, elem) => {
                let $el = $(elem);
                if ($el.is(".admin-orderer__item--placeholder") || $el.is(".admin-orderer__item--dragging")) return;

                let offset = $el.offset();
                offset.bottom = offset.top + $el.outerHeight();

                if (offset.top < e.pageY && e.pageY < offset.bottom) {
                    if (currentIndex > index) {
                        $el.before(this.$originalElement);
                    } else {
                        $el.after(this.$originalElement);
                    }
                    return false;
                }
            });
        } else {
            $(window).off('mousemove', this.handleMouseMove).off("mouseup", this.handleMouseUp)
        }
    }

    handleMouseUp() {
        if (this.$draggingElement !== null) {
            this.$originalElement.removeClass("admin-orderer__item--placeholder");
            this.$draggingElement.remove();

            this.items = this.$element.children().map((_, el) => $(el).data("item")).get();
            this.updateList();
            this.emit('ordered', this.items);

            this.$originalElement = null;
            this.$draggingElement = null;
        }
        $(window).off('mousemove', this.handleMouseMove).off("mouseup", this.handleMouseUp)
    }

    setItems(items) {
        this.items = items;
        this.updateList();
    }

    addItem(item) {
        this.items.push(item);
        this.updateList();
    }

    updateList() {
        this.$element.html(this.items.map((item) => this.buildItem(item)));
    }

    buildItem(item) {
        return (
            eotwJSXFactory('div', {class: "admin-orderer__item js-orderer-item"}, [
                eotwJSXFactory('span', null, [item.name]),
                item.subText ? eotwJSXFactory('small', null, [" - ", item.subText]) : undefined,
                eotwJSXFactory('div', {class: "admin-orderer__item__actions"}, [
                    item.removable === true ? (
                        eotwJSXFactory('button', {type: "button", class: "admin-btn admin-btn--icon js-remove-item"}, [
                            eotwJSXFactory('span', {class: "admin-btn__icon"}).html("<svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='" + window.CONFIG.adminBuildUrl + "base/icons.svg#delete'></use></svg>")
                        ])
                    ) : undefined
                ])
            ])
        ).data("item", item)
    }

}

export default ItemOrderer;
